module.exports = __webpack_public_path__ + "src/assets/chinese-new-year-100.png";